import Button from '~/client/shared/Button';
import useDepositButton from '../hooks/useDepositButton';
import ControlsPlus from '@/external/icons/ControlsPlus';

type Props = { text: string };

const DepositButtonMobile: FC<Props> = ({ text }) => {
  const { onClick } = useDepositButton();
  return (
    <Button
      className="h-8 w-8 rounded-full p-0"
      variant="primary"
      aria-label={text}
      onClick={onClick}
    >
      <ControlsPlus fontSize={24} color="goten" />
    </Button>
  );
};

export default DepositButtonMobile;
